import React from 'react'
import { Table } from '@phosphor-icons/react'
import styles from './TableEmpty.module.scss'

/**
 * TableEmpty - Empty state for ScoopTable
 * Displays when there is no data to show
 */
const TableEmpty = ({ message = 'No data available', icon: CustomIcon, children }) => {
    const IconComponent = CustomIcon || Table

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <IconComponent size={48} weight="light" className={styles.icon} />
                <p className={styles.message}>{message}</p>
                {children && <div className={styles.actions}>{children}</div>}
            </div>
        </div>
    )
}

export default TableEmpty
